import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isLoaded, setIsLoaded] = useState(false);
  const containerRef = useRef(null);
  const particlesRef = useRef(null);
  const particles = useRef([]);
  const numParticles = 80;

  // Animation d'entrée
  useEffect(() => {
    setTimeout(() => {
      setIsLoaded(true);
    }, 300);
  }, []);
  
  // Initialisation des particules
  useEffect(() => {
    if (particlesRef.current) {
      for (let i = 0; i < numParticles; i++) {
        particles.current.push({
          x: Math.random() * window.innerWidth,
          y: Math.random() * window.innerHeight,
          size: Math.random() * 3 + 1,
          speedX: Math.random() * 2 - 1,
          speedY: Math.random() * 2 - 1,
          opacity: Math.random() * 0.5 + 0.1,
        });
      }
      
      const canvas = particlesRef.current;
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      
      animateParticles();
    }
    
    // Nettoyage
    return () => {
      particles.current = [];
    };
  }, []);
  
  // Animation des particules
  const animateParticles = () => {
    if (!particlesRef.current) return;
    
    const canvas = particlesRef.current;
    const ctx = canvas.getContext('2d');
    
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    particles.current.forEach(particle => {
      // Mouvement
      particle.x += particle.speedX;
      particle.y += particle.speedY;
      
      // Rebond sur les bords
      if (particle.x < 0 || particle.x > canvas.width) particle.speedX *= -1;
      if (particle.y < 0 || particle.y > canvas.height) particle.speedY *= -1;
      
      // Dessin de la particule
      ctx.beginPath();
      ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(179, 135, 246, ${particle.opacity})`;
      ctx.fill();
      
      // Connexion entre particules proches
      particles.current.forEach(otherParticle => {
        const dx = particle.x - otherParticle.x;
        const dy = particle.y - otherParticle.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        
        if (distance < 100) {
          ctx.beginPath();
          ctx.moveTo(particle.x, particle.y);
          ctx.lineTo(otherParticle.x, otherParticle.y);
          ctx.strokeStyle = `rgba(179, 135, 246, ${0.2 - distance/500})`;
          ctx.lineWidth = 0.5;
          ctx.stroke();
        }
      });
    });
    
    requestAnimationFrame(animateParticles);
  };
  
  // Effet de suivi du curseur
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!containerRef.current) return;
      
      const rect = containerRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      setMousePosition({ x, y });
    };
    
    window.addEventListener('mousemove', handleMouseMove);
    
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
  
  // Définition de la position du gradient qui suit la souris
  const gradientPosition = `radial-gradient(circle at ${mousePosition.x}px ${mousePosition.y}px, rgba(179, 135, 246, 0.2) 0%, rgba(92, 122, 250, 0.1) 40%, transparent 70%)`;

  return (
    <div className="not-found-container" ref={containerRef}>
      {/* Background image avec overlay */}
      <div className="not-found-background"></div>
      
      {/* Effet de particules en arrière-plan */}
      <canvas 
        ref={particlesRef} 
        className="not-found-particles"
      />
      
      {/* Gradient qui suit la souris */}
      <div 
        className="not-found-mouse-gradient"
        style={{ background: gradientPosition }}
      />
      
      {/* Contenu principal */}
      <div className="not-found-content">
        <div className={`not-found-title ${isLoaded ? 'loaded' : ''}`}>
          <h1>
            <span className="not-found-404">404</span>
            <div className="not-found-glitch-wrapper">
              <div className="not-found-glitch" data-text="PAGE NON TROUVÉE">PAGE NON TROUVÉE</div>
            </div>
          </h1>
        </div>
        
        <div className={`not-found-message ${isLoaded ? 'loaded' : ''}`}>
          <p>La page que vous recherchez semble avoir disparu dans le cyberespace...</p>
        </div>
        
        <div className={`not-found-buttons ${isLoaded ? 'loaded' : ''}`}>
          <Link to="/" className="not-found-home-button">
            <span className="button-text">Retour à l'accueil</span>
            <span className="button-icon">
              <i className="fas fa-home"></i>
            </span>
          </Link>
          
          <Link to="/contact" className="not-found-contact-button">
            <span className="button-text">Contact</span>
            <span className="button-icon">
              <i className="fas fa-envelope"></i>
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;